import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
import { ALL_SERVICES, PRIMARY_SERVICES } from 'pricing-pages-lib/constants/AllAvailableServices';
import { getAddonRestrictionDetails } from '../constants/addonsAndServices/AddonsRestrictionMap';
import { AdditionalServicesRestrictionMap } from '../constants/addonsAndServices/ServicesRestrictionMap';
import { hasPricingAndPurchasingSucceededSelector } from './LoadingStateSelectors';
import { currentProductVersionSelector, currentSkuIdForProductSelector, productSelector } from './ProductsSelectors';
export const eligibleAddOnSkuIdsSelector = (state, {
  selectedProductConfigurations
}) => {
  if (!hasPricingAndPurchasingSucceededSelector) return [];
  return ALL_AVAILABLE_ADD_ONS.filter(apiName => {
    const product = productSelector(state, {
      apiName
    });
    if (!product) return false;
    const {
      id: productId
    } = product;
    const productVersion = currentProductVersionSelector(state, {
      productId
    });
    if (!productVersion) return false;
    const {
      versionNumber
    } = productVersion;
    const restrictionDetails = getAddonRestrictionDetails({
      apiName,
      versionNumber
    });
    return !restrictionDetails || !restrictionDetails.isRestricted(state, {
      productConfigurations: selectedProductConfigurations
    });
  }).map(apiName => currentSkuIdForProductSelector(state, {
    apiName
  }));
};
export const eligibleServiceSkuIdsSelector = (state, {
  selectedProductConfigurations
}) => {
  if (!hasPricingAndPurchasingSucceededSelector(state)) return [];
  const services = [...PRIMARY_SERVICES];
  Object.keys(AdditionalServicesRestrictionMap).forEach(service => {
    if (service in AdditionalServicesRestrictionMap && !AdditionalServicesRestrictionMap[service].isRestricted(state, {
      productConfigurations: selectedProductConfigurations
    })) {
      services.push(service);
    }
  });
  return services.sort((firstApiName, secondApiName) => ALL_SERVICES.indexOf(firstApiName) - ALL_SERVICES.indexOf(secondApiName)).map(apiName => currentSkuIdForProductSelector(state, {
    apiName
  })).filter(currentSkuId => currentSkuId); // filter out services that do not have a CURRENT version, mostly for when we're launching a new service.
};